var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource-collection',{scopedSlots:_vm._u([{key:"default",fn:function({item}){return [_c('order',{attrs:{"order":item}})]}}])},[_c('orders-report-button',{attrs:{"slot":"before-actions","btn-class":"m-1","popover-type":"popover-sm popover-dark popover-bottom-left md:popover-bottom"},slot:"before-actions"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }